import { BaseRouteService } from 'core/services';

class InsuranceRouteService extends BaseRouteService {
    constructor() {
        super('insurances');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery}', filter);
    }

    invalidate(){
        return super.delete(this.base + '/invalidate');
    }

}

export default InsuranceRouteService;
